import { ChatMarkdown } from '@/modules/common/Chat/components/ChatMarkdown';

import { HouseholdChatMessage } from '../../contexts/householdChat.context';

interface TextMessageRendererProps {
  message: HouseholdChatMessage;
}

export function TextMessageRenderer({ message }: TextMessageRendererProps) {
  return <ChatMarkdown markdown={message.content} />;
}
